import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyFeedbackCollectorManager: FunctionComponent = () => {
  const FeedbackCollectorManager = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "feedback-collector-manager", webpackPrefetch: true */ './FeedbackCollectorManager'
      ),
    { namedImport: 'FeedbackCollectorManager' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Feedback Collector',
      }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <FeedbackCollectorManager />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
